/**
 * @description
 *	Available AWS regions for the entire application.
 *
 * @see https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/Concepts.RegionsAndAvailabilityZones.html
 */
enum Region {
	Africa_CapeTown = "af-south-1",
	AsiaPacific_HongKong = "ap-east-1",
	AsiaPacific_Hyderabad = "ap-south-2",
	AsiaPacific_Jakarta = "ap-southeast-3",
	AsiaPacific_Malaysia = "ap-southeast-5",
	AsiaPacific_Melbourne = "ap-southeast-4",
	AsiaPacific_Mumbai = "ap-south-1",
	AsiaPacific_Osaka = "ap-northeast-3",
	AsiaPacific_Seoul = "ap-northeast-2",
	AsiaPacific_Singapore = "ap-southeast-1",
	AsiaPacific_Sydney = "ap-southeast-2",
	AsiaPacific_Tokyo = "ap-northeast-1",
	AWSGovCloud_USEast = "us-gov-east-1",
	AWSGovCloud_USWest = "us-gov-west-1",
	Canada_Central = "ca-central-1",
	CanadaWest_Calgary = "ca-west-1",
	Europe_Frankfurt = "eu-central-1",
	Europe_Ireland = "eu-west-1",
	Europe_London = "eu-west-2",
	Europe_Milan = "eu-south-1",
	Europe_Paris = "eu-west-3",
	Europe_Spain = "eu-south-2",
	Europe_Stockholm = "eu-north-1",
	Europe_Zurich = "eu-central-2",
	Israel_TelAviv = "il-central-1",
	MiddleEast_Bahrain = "me-south-1",
	MiddleEast_UAE = "me-central-1",
	SouthAmerica_SãoPaulo = "sa-east-1",
	USEast_NorthVirginia = "us-east-1",
	USEast_Ohio = "us-east-2",
	USWest_NorthCalifornia = "us-west-1",
	USWest_Oregon = "us-west-2"
}

export default Region
